import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthContext from '../../services/authContext'
import EyeSlash from '../../components/icons/EyeSlash'
import Eye from '../../components/icons/Eye'
import PrimaryButton from '../../components/buttons/PrimaryButton'
import { motion } from 'framer-motion'
import InputPrimary from '../../components/forms/InputPrimary'

const LoginWithEmail = () => {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [keepLogin, setKeepLogin] = useState(false)
  const [error, setError] = useState(null)
  const [showPassword, setShowPassword] = useState(false)

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  const handleLogin = async (method = 'email') => {
    try {
      setError(null)
      await AuthContext.login(method, email, password, keepLogin)
      navigate('/')
    } catch (error) {
      setError(error.message)
    }
  }

  const handleLoginOC = async () => {
    try {
      let ocAuth
      await ocAuth.signInWithRedirect({ state: 'opencampus' })
    } catch (error) {
      setError(`Login error: ${error}`)
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleLogin()
    }
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -50 }}
      transition={{ duration: 0.5 }}
      className="md:container mx-auto md:px-4 min-h-screen md:min-h-full"
      onKeyDown={handleKeyDown}
    >
      <div className="bg-white p-6 w-full mx-auto rounded-lg shadow max-w-[648px]">
        <p className="text-3xl text-primary font-bold text-center mb-6">
          Welcome Back
        </p>
        <p className="text-base font-normal text-center text-black mb-6">
          Ready to continue your journey?
          <br />
          Let’s go back to MAD World!
        </p>

        {error && <p className="text-red-500 text-center mb-4">{error}</p>}

        <div className="mb-4">
          <label className="mb-4 font-bold">Email</label>
          <InputPrimary
            type="email"
            placeholder="Please enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="mb-6 relative">
          <label className="mb-4 font-bold">Password</label>
          <InputPrimary
            type={showPassword ? 'text' : 'password'}
            placeholder="Please enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            type="button"
            disabled={!password}
            onClick={togglePasswordVisibility}
            className="absolute right-2 bottom-0 transform -translate-y-1/2 w-6"
          >
            {showPassword ? (
              <EyeSlash size="6" />
            ) : (
              <Eye color={password ? '#DC7B19' : '#9E9E9E'} size="6" />
            )}
          </button>
        </div>

        <div className="mb-4">
          <a href="#">Forgot Password</a>
        </div>

        <div className="mb-4 flex items-center">
          <input
            type="checkbox"
            id="keep-signed-in"
            onChange={(e) => setKeepLogin(e.target.checked)}
            className="w-6 h-6 border-2 text-green-600 bg-gray-100 border-gray-500 rounded focus:ring-0"
          />
          <label
            htmlFor="keep-signed-in"
            className="ml-2 text-lg font-medium text-gray-900"
          >
            Keep me signed in
          </label>
        </div>

        <div className="flex flex-col gap-6 items-center justify-between mb-4">
          <PrimaryButton className="w-full" onClick={() => handleLogin()}>
            Log In
          </PrimaryButton>
        </div>
      </div>
    </motion.div>
  )
}

export default LoginWithEmail
